module.exports = __webpack_public_path__ + "static/img/3.cb12170c.png";